/**
 * Polyfill for process and process.env
 * This ensures that libraries relying on 'process' (like Redux Toolkit in dev mode)
 * do not throw ReferenceErrors when running in the browser.
 */
if (typeof window !== 'undefined' && !window.process) {
  ;(window as Window & { process?: any }).process = {
    env: {
      NODE_ENV: 'development',
      PUBLIC_URL: '',
    },
    version: '',
    nextTick: (fn: any, ...args: any[]) => setTimeout(() => fn(...args), 0),
  }
}

export {}
